import {Component, computed, HostListener, inject} from '@angular/core';
import {environment} from "projects/store/src/environments/environment";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SalesWorkflow} from "../../../../enums";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";

@Component({
  selector: 'app-sales-header',
  templateUrl: './sales-header.component.html'
})
export class SalesHeaderComponent {
  isScrolled = false;
  isOffsetTop = false;
  country = environment.global.country
  isMexico = environment.global.country.code === 'MX';
  phoneNumber: string;
  phoneKredicashNumber: string;
  private requestService = inject(RequestService);
  private readonly authService = inject(AuthService);
  private readonly salesWorkflowService = inject(SalesWorkflowService);
  public router = inject(Router);
  stepNumber = computed( ()=>  this.requestService.step() )
  showButtonInit = computed(  () => this.authService.isAuthenticated() && !this.router.url.includes('/inicio'));

  constructor() {
    this.phoneNumber = this.country.customerServicePhone.replace(/\D/g, '');
    this.phoneKredicashNumber = this.country.customerServiceKredicashPhone.replace(/\D/g, '');
  }

  get phoneNumberService(): string {
    const code = this.salesWorkflowService.workflow?.code?.toLowerCase();
    return code && code.includes(SalesWorkflow["kredicash-cliente"]) ? this.phoneKredicashNumber : this.phoneNumber;
  }


  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    this.isScrolled = scrollPosition > 60;
    this.isOffsetTop = scrollPosition > 0;
  }

  goTODashboard() {
    this.router.navigate(['/inicio']);
  }

  protected readonly SalesWorkflow = SalesWorkflow;
}
